// Module
var code = "<div class=\"tbx-modal\" ng-click=\"$dismiss()\"> <div class=\"modal-body\" id=\"modal-body\"> <img class=\"tbx-bd-img-lg\" ng-show=\"signature.image.image\" ng-src=\"{{signature.image.image}}\">  <br/> <div class=\"modal-label text-center\">{{ signature.printed_name }}</div> </div> </div> ";
// Exports
module.exports = code;